import request from '@/utils/request'

// 获取收款账户列表
export function getAccountList(data) {
  return request({
    method: 'post',
    path: 'account/lists',
    data
  })
}

// 保存收款账户
export function saveAccount(data) {
  return request({
    method: 'post',
    path: 'account/save',
    data
  })
}


// 删除收款账户
export function deleteAccount(data) {
  return request({
    method: 'post',
    path: 'account/delete',
    data
  })
}


// 获取收款账户列表（所有）
export function getAllAccountList(data) {
  return request({
    method: 'post',
    path: 'account/all',
    data
  })
}
